// Gambar lewat proxy /api/notion-image di-bypass dari optimizer next/image:
// di Vercel, /_next/image gagal (404) saat fetch sumber dari route API ini,
// padahal route-nya sendiri balikin gambar dengan benar.
export const isNotionProxy = (src?: string | null) =>
  !!src && src.startsWith("/api/notion-image/");
